import { apiStudent } from '@/lib/api-manager'
import type { DesiredEducationCourse } from '@/types/education/desired-education-course'

export async function getStudentDesiredducationCoursesByRequest(
  requestId?: string
) {
  const { data } = await apiStudent.get(
    `v1/requests/request/${requestId}/desired-education/courses`
  )

  return (data?.data ?? []) as DesiredEducationCourse[]
}
